export default __webpack_public_path__ + "static/media/certificates14001.5a5691ff.png";